import t from 'tcomb';
import Locale from './Locale';
import Mobile from './Mobile';
import Gender from './Gender';
import Email from './Email';
import Datetime from './Datetime';
import Register_Country from './Register_Country';

const Verified = t.struct({
  email: Email,
  mobile: Mobile,
  mobile_country: t.maybe(t.Str),
  name: t.maybe(t.Str),
  surname: t.maybe(t.Str),
  birth_date: Datetime,
  gender: Gender,
  country: Register_Country,
  district: t.Str,
  zip: t.Str,
  com_locale: Locale,
  rcs_privacy_needed: t.Bool
}, 'Verified');

module.exports = Verified;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Verified.js
 **/